import React, { useState } from "react";
import PropTypes from "prop-types";
import { Row } from "reactstrap";
import { isB2C } from "../../libs/env";

const ConfirmSetupModal = ({ toggle, setAssessmentStarted, isSpeaktest, setIsconfirmSetting, IsconfirmSetting }) => {
  let name = "NOVIUM";
  const [ShowError, setisShowError] = useState(false);
  return (
    <div className="px-3 smps-4">
          <div className="col-12 smp-5 pb-5">
            {isB2C.some(domain => window.location.origin.includes(domain)) ?(
             <div className="col-12 d-flex pb-5 pt-4 px-5 smpx-5 center">
             <div className="d-flex align-items-start">
               <input type="checkbox" id="acknowledge" className="me-2 mt-2" />
               <label htmlFor="acknowledge" className="f-13">
                 <b>By continuing, you acknowledge that you have checked your system requirements. Prosperity English cannot be held responsible for any issues that may arise due to insufficient hardware or software.</b>
               </label>
             </div>
           </div>
           
            ): isSpeaktest ? (
              <div className="col-12 pb-5 pt-4 px-5 smpx-5">
                <div className="d-flex align-items-start">
                  <input type="checkbox" id="acknowledge" className="me-2 mt-2" onClick={()=> {
                    setIsconfirmSetting(!IsconfirmSetting); 
                    setisShowError(false);
                  }} />
                  <label htmlFor="acknowledge" className="f-13">
                    <b>By continuing, you acknowledge that you have checked your system requirements. Lingtung cannot be held responsible for any issues that may arise due to insufficient hardware or software.</b>
                  </label>
                </div>
                {ShowError && (
                  <p style={{color: "red"}}>To proceed, please agree to the system requirements</p>
                )}
              </div>
            ):(
              <div className="col-12 d-flex pb-5 pt-4 px-5 smpx-5 center">
                <div className="ps-4 f-13"><b>By continuing, you acknowledge that you have checked your system requirements. {name} cannot be held responsible for any issues that may arise due to insufficient hardware or software.</b></div>
              </div>
            )}
          </div>
        <Row className="px-4 pt-3">
            <div className="align-text sm-pe-4 d-flex justify-content-end">
            <button type="button"class="btn btn-warning euro-color"  onClick={() => {
              if(isSpeaktest){
                if(IsconfirmSetting)
                {
                  setAssessmentStarted(true);
                  toggle();
                }else{
                  setisShowError(true)
                }
              }else{
                setAssessmentStarted(true);
                toggle();
              }
            }}>Confirm</button>

                {/* <button
                  type="button"
                  class="btn p-0 text-dark border-bottom-dark me-4"
                  onClick={() => {
                  setAssessmentStarted(true);
                  toggle();
                  }}
                >
                  Skip for now
                </button> */}
                {/* <SimpleButton
                label={"Start Test"}
                data-tc="confirm-setup-modal"
                className="btn btn-warning px-3 py-1"
                onClick={() => {
                setAssessmentStarted(true);
                toggle();
                }}
                /> */}
            </div>
        </Row>
    </div>
  );
};

ConfirmSetupModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

ConfirmSetupModal.defaultProps = { isOpen: false };

export default ConfirmSetupModal;